import React from 'react';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import PageBuilder from '../PageBuilder/PageBuilder';

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error,projects, isFeaturedListing,
    queryProjectsInProgress, queryProjectsError ,isAuthenticated, onToggleFavorite } = props;
    
  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
      inProgress={inProgress}
      projects={projects}
      onToggleFavorite={onToggleFavorite}
      queryProjectsInProgress={queryProjectsInProgress}
      queryProjectsError={queryProjectsError}
      error={error}
      options={{
        projects: projects,
        isFeaturedListing:isFeaturedListing,
        isAuthenticated:isAuthenticated,
        onToggleFavorite:onToggleFavorite,
        queryProjectsInProgress: queryProjectsInProgress,
        queryProjectsError: queryProjectsError,
      }}
      fallbackPage={<FallbackPage error={error} />}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const {
    projectRefs,
    isFeatured,
    queryProjectsInProgress,
    queryProjectsError,
  } = state.LandingPage;
 
   const { isAuthenticated, } = state.auth;
  const projects = getListingsById(state, projectRefs);
  const isFeaturedListing = getListingsById(state, isFeatured);
  return { pageAssetsData, inProgress, error,projects,isFeaturedListing, queryProjectsInProgress, queryProjectsError,isAuthenticated };  
};
const mapDispatchToProps = dispatch => ({
  // onToggleFavorite: favoriteId => dispatch(toggleFavorite(favoriteId)),
  onToggleFavorite: data => dispatch(updateProfile(data)),
});
// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps, mapDispatchToProps))(LandingPageComponent);

export default LandingPage;
